var map = {
	"./decidim/avatar-multiuser.png": 38161,
	"./decidim/brands/facebook.svg": 86165,
	"./decidim/brands/google.svg": 60092,
	"./decidim/brands/twitter-x.svg": 28969,
	"./decidim/cc-badge.png": 66135,
	"./decidim/decidim-logo.svg": 57923,
	"./decidim/default-avatar.svg": 24471,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 59469,
	"./decidim/icons.svg": 91414,
	"./decidim/pattern.png": 18773,
	"./decidim/placeholder-card-g.svg": 410,
	"./decidim/placeholder-card-l.svg": 37233,
	"./decidim/placeholder.jpg": 46832,
	"./decidim/remixicon.symbol.svg": 62050,
	"./decidim/vendor/social-share-button/douban.svg": 45829,
	"./decidim/vendor/social-share-button/email.svg": 3430,
	"./decidim/vendor/social-share-button/facebook.svg": 86222,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 17058,
	"./decidim/vendor/social-share-button/hacker_news.svg": 16998,
	"./decidim/vendor/social-share-button/linkedin.svg": 90172,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 74261,
	"./decidim/vendor/social-share-button/pinterest.svg": 78336,
	"./decidim/vendor/social-share-button/reddit.svg": 97434,
	"./decidim/vendor/social-share-button/telegram.svg": 13611,
	"./decidim/vendor/social-share-button/tumblr.svg": 67048,
	"./decidim/vendor/social-share-button/twitter.svg": 43051,
	"./decidim/vendor/social-share-button/vkontakte.svg": 91361,
	"./decidim/vendor/social-share-button/wechat.svg": 86964,
	"./decidim/vendor/social-share-button/whatsapp.svg": 48908,
	"./decidim/vendor/social-share-button/x.svg": 39150,
	"./decidim/vendor/social-share-button/xing.svg": 47978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51520;